import { facebookFormatUrl } from './facebook-format-url';

export const createFacebookIframe = (url: string): string => {
  const src = facebookFormatUrl(url);
  return `<iframe src="${src}" width="100%" height="228" style="background-color:#fff;border:none;overflow:hidden;" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>`;
};
